import { type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconTag } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'

import { ProductPriceExplainerDialog } from './ProductPriceExplainerDialog'

export const ProductPriceExplainer = (): ReactNode => {
  const priceExplainerControls = useOpenableControls()

  return (
    <>
      <Button
        onClick={priceExplainerControls.handleOpen}
        size="medium"
        startIcon={<IconTag />}
        variant="text"
      >
        <FormattedMessage id="product.legalPriceInformation.dialogTrigger" />
      </Button>
      {priceExplainerControls.isOpen ? (
        <ProductPriceExplainerDialog
          onClose={priceExplainerControls.handleClose}
        />
      ) : null}
    </>
  )
}
